// extracted by mini-css-extract-plugin
module.exports = {"Confirmation":"Confirmation_Confirmation__2tBPN","title":"Confirmation_title__3eQOb","content":"Confirmation_content__1Q343","toHome":"Confirmation_toHome__25uU7"};